var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 1.89121V5.33332C11.6666 5.80003 11.6666 6.03339 11.7575 6.21165C11.8374 6.36845 11.9649 6.49593 12.1217 6.57583C12.2999 6.66666 12.5333 6.66666 13 6.66666H16.4421M16.6666 8.32351V14.3333C16.6666 15.7335 16.6666 16.4335 16.3942 16.9683C16.1545 17.4387 15.772 17.8212 15.3016 18.0608C14.7668 18.3333 14.0668 18.3333 12.6666 18.3333H7.33331C5.93318 18.3333 5.23312 18.3333 4.69834 18.0608C4.22793 17.8212 3.84548 17.4387 3.6058 16.9683C3.33331 16.4335 3.33331 15.7335 3.33331 14.3333V5.66666C3.33331 4.26653 3.33331 3.56646 3.6058 3.03168C3.84548 2.56128 4.22793 2.17882 4.69834 1.93914C5.23312 1.66666 5.93318 1.66666 7.33331 1.66666H10.0098C10.6213 1.66666 10.927 1.66666 11.2147 1.73573C11.4698 1.79697 11.7137 1.89798 11.9374 2.03506C12.1897 2.18966 12.4058 2.40585 12.8382 2.83823L15.4951 5.49508C15.9275 5.92746 16.1436 6.14365 16.2982 6.39594C16.4353 6.61962 16.5363 6.86349 16.5976 7.11858C16.6666 7.4063 16.6666 7.71203 16.6666 8.32351Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.27efab78e11599c077e9531262ca533c.svg";
export { ForwardRef as ReactComponent };